
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.645 23.905c-1.57-4.908-.274-10.958 3.853-18.002 1.043 1.752 2.084 3.364 3.097 4.935 4.927 7.635 8.527 13.243 4.697 23.609a47.397 47.397 0 01-1.546-2.349c-.734-1.17-1.46-2.297-2.113-3.481-1.31-2.357-2.369-4.859-3.043-7.483-.647-2.625-.91-5.361-.698-8.085-.368 2.706-.265 5.481.241 8.188.531 2.703 1.465 5.326 2.668 7.812.596 1.244 1.281 2.454 1.931 3.636.218.411.45.824.678 1.237-5.249-2.645-8.459-5.938-9.765-10.017m18.193 16.826c-1.906-1.28-3.648-2.715-5.117-4.431 4.902-12.044.778-18.452-4.445-26.547-1.275-1.973-2.59-4.015-3.892-6.3L18.557 2l-.889 1.416c-5.133 8.177-6.792 15.276-4.927 21.098 1.707 5.337 6.16 9.423 13.613 12.493 1.476 2.049 3.346 3.828 5.31 5.341l.006.007a1.002 1.002 0 001.441-.235 1.003 1.003 0 00-.273-1.389"}})])
          )
        }
      }
    